var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19924 32.479L8.20743 32.4758L8.21558 32.4725C13.0789 30.4942 17.6688 29.5322 22 29.5322C26.3301 29.5322 30.8736 30.4937 35.6446 32.4679L35.6637 32.4758L35.6829 32.4833C40.545 34.3787 42 36.5092 42 38.4678V42H2V38.4678C2 36.4901 3.43999 34.3663 8.19924 32.479ZM15.6949 4.75924L15.7088 4.74538L15.7224 4.73125C17.5025 2.8799 19.5605 2 22 2C24.4395 2 26.4975 2.8799 28.2776 4.73125L28.2912 4.74538L28.3051 4.75924C30.0785 6.5327 30.9357 8.59883 30.9357 11.0643C30.9357 13.5298 30.0785 15.596 28.3051 17.3694C26.5316 19.1429 24.4655 20 22 20C19.5345 20 17.4684 19.1429 15.6949 17.3694C13.9215 15.596 13.0643 13.5298 13.0643 11.0643C13.0643 8.59883 13.9215 6.5327 15.6949 4.75924Z",
    stroke: "#BEBEBE",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.445a99f7543585b50abde42acc805a64.svg";
export { ForwardRef as ReactComponent };